import DragItem from "../../ddTxtImg/model/DragItem";
import DropItem from "../../ddTxtImg/model/DropItem";

class DropItemModel  extends DropItem{

    constructor() {
        super()
        this.dropItemId = 0;
        this.dropItemName = ""
        
    }
    getAsJson = () => {
        let obj = {}
        obj.dropItemId = this.dropItemId
        obj.dropItemName = this.dropItemName
       obj.solvedDragItem = this.solvedDragItem.getAsJson()

        obj.dragList = []

        for (let i = 0; i < this.dragList.length; i++) {
            obj.dragList.push(this.dragList[i].getAsJson())
        }

        return obj
    }


    initFromJson = (obj) => {
        this.dropItemId = obj.dropItemId
        this.dropItemName = obj.dropItemName
        this.solvedDragItem.initFromJson(obj.solvedDragItem)
        for (let i = 0; i < obj.dragList.length; i++) {
            let dragItem=new DragItem()
            dragItem.initFromJson(obj.dragList[i])
            this.dragList.push(dragItem)
        }

      if(this.solvedDragItem.dragIndex!=-1){
          this.dropTxt=this.solvedDragItem.dragTxt
      }
    }

    getReviewColor=()=>{
        return (this.isAnsewredTrue())?"green":"red"
    }
}
export default DropItemModel
